"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { ComboBoxTag } from '../../ComboBoxElements/ComboBoxTag.mjs';
import { Tag } from '../../Tag/Tag.mjs';
import '../../Tag/TagPlaceholder.mjs';
import { Truncate } from '../../Truncate/index.mjs';

const LookupFormula = forwardRef((props, ref) => {
  const { formula } = props;
  const isConfigError = Object.entries(formula.value?.query ?? {}).length === 0;
  return /* @__PURE__ */ jsxs(ComboBoxTag, { ref, variant: "lookup", children: [
    isConfigError && /* @__PURE__ */ jsx(Tag.SvgIcon, { type: SvgIconType.AlertTriangle }),
    /* @__PURE__ */ jsx(Truncate, { children: "Select Dynamically" })
  ] });
});
LookupFormula.displayName = "LookupFormula";

export { LookupFormula as default };
